/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentColors = {
    type: 'array',
    contains: {
        type: 'DepartmentColor',
    },
};